import React from 'react';
import { chunk } from 'lodash-es';
import { Markup } from 'interweave';
import Stats from '@strava/ui/Stats';
import Stat from '@strava/ui/Stat';
import styles from '../index.scss';
import { statsProps } from '../../../../props/feed-prop-types';

const ActivityStats = ({ stats }) => (
  <Stats listClassName={`${styles.stats} mt-0`}>
    {chunk(stats, 2).map((stat) => {
      return (
        <Stat
          value={<Markup noWrap={true} content={stat[0].value} />}
          labelClassName={styles.statLabel}
          label={stat[1].value}
          key={stat[1].value}
        />
      );
    })}
  </Stats>
);

ActivityStats.propTypes = {
  stats: statsProps
};

ActivityStats.defaultProps = {
  stats: []
};

export default ActivityStats;
